import { data } from '../../svg/SyncDisabled/data';
import { makeIcon } from '../makeIcon';

export const SyncDisabled = makeIcon(data, 'sync_disabled', 'SyncDisabled');

export default SyncDisabled;
